/**
 * This is a port from the server side code
 */
export default class URLONUtil {
    /**
     * 
     * @param params 
     * @param url 
     * @param override 
     * 
     * @returns 
     */
    toUrl(params: Record<string, any>, url?: string, override?: boolean) {
        if (!url) {
            url = "";
        } else {
            const index = url.indexOf("?");
            if (index >= 0) {
                if (!override) {
                    var prevParams = es.util.URLON.fromUrl(url);
                    params = $.extend(prevParams, params);
                }
                url = url.substring(0, index + 1);
            }
        }

        const ret: string[] = [];
        ret.push(url);
        let index = 0;
        for (let key in params) {
            if (index) {
                ret.push("&");
            } else {
                index = 1;
            }
            const value = params[key];
            let valueStr: string[] | string = [];
            renderSimple(value, valueStr);
            valueStr = valueStr.join("");
            ret.push(encodeURIComponent(key), "=", encodeURIComponent(valueStr));
        }

        url = ret.join("");
        return url;
    }
    
    /**
     * 
     * @param url 
     * @param ret 
     * 
     * @returns 
     */
    fromUrl(url: string, ret?: Record<string, any>) {
        if (!ret) {
            ret = {};
        }
        
        // ignore hash
        if (url.indexOf('#') >= 0) {
            url = url.substring(url.indexOf('#'));
        }
        
        let index = url.indexOf("?");
        if (index >= 0) {
            index++;
            while ((index > 0) && (index < url.length)) {
                var nextIndex = url.indexOf("=",index);
                var key = decodeURIComponent(url.substring(index, nextIndex));
                index = nextIndex+1;
                nextIndex = url.indexOf("&",index);
                if(nextIndex < 0){
                    nextIndex = url.length;
                }
                var value = decodeURIComponent(url.substring(index, nextIndex));
                value = parseSimple(value, 0).element;
                ret[key] = value;
                index = nextIndex+1;
            }
        }

        return ret;
    }
    
    parse(input: string): ParsedElement<any> {
        return parseSimple(input,0).element;
    }
    
    render(value: any): string {
        const valueStr: any[] = [];
        renderSimple(value, valueStr);
        return valueStr.join("");
    }
}

function parseSimple(input: string, startIndex: number) {
    let c = input.charAt(startIndex);
    if (c === "(") {
        return parseComplex(input, startIndex);
    } else {
        const array = [];
        let index = startIndex;
        while (index < input.length) {
            c = input.charAt(startIndex);
            if (c === "\'") {
                const result = parseQuotedString(input, index+1);
                array.push(result.element);
                index = result.index;
                if(index < input.length){
                    c = input.charAt(index);
                    if((c !== ",") && (c !== "~")){
                        throw new URLONException(input, index, "Unexpected character: " + c); //check if comma or tilda
                    }
                }
            } else {
                startIndex = index;
                while(++index < input.length){
                    c = input.charAt(index);
                    if((c === "~") || (c === ",")){
                        break;
                    }
                }
                var value = input.substring(startIndex, index);
                switch (value) {
                    case "null":
                        array.push(null);
                        break;
                    case "true":
                        array.push(true);
                        break;
                    case "false":
                        array.push(false);
                        break;
                    default:
                        var f = +value;
                        if(isNaN(f)){
                            if(value === "NaN"){
                                array.push(f);
                            }else{
                                array.push(value);
                            }
                        }else{
                            array.push(f);
                        }
                }                    
            }

            if (index < input.length) {
                index++;
            }
        }

        return {element : ((array.length === 1) ? array[0] : array), index : index};
    }
}

type ParsedElement<T> = {
    element: T,
    index: number
}

/**
 * 
 * @param input 
 * @param index 
 * 
 * @returns 
 */
function parseComplex(input: string, index: number): ParsedElement<any> | undefined {
    var c = input.charAt(index++);
    switch (c) {
        case "(":
            if (input.charAt(index) === "!") {
                return parseArray(input, index + 1);
            } else {
                return parseObject(input, index);
            }
        case "'":
            return parseQuotedString(input, index);
        default:
            return parsePrimitive(input, index - 1); // either a null, true, false or number
    }
}

//parse an array
function parseArray(input: string, index: number): ParsedElement<Array<any>> {
    const array = [];
    let c = input.charAt(index);
    while (c !== ")") {
        const valueResult = parseComplex(input, index);
        array.push(valueResult.element);
        index = valueResult.index;
        c = input.charAt(index);
        if (c === "~") {
            index++;
            c = input.charAt(index);
        } else if (c !== ")") {
            err(input,index,c);
        }
    }

    return {element : array, index : index + 1};
}

//Parse an object. continue parsing key value pairs until encounter )
function parseObject(input: string, index: number): ParsedElement<Record<string, any>> {
    const obj: Record<string, any> = {};
    let c = input.charAt(index);
    while (c !== ")") {
        let keyResult;
        if (c === "'") {
            keyResult = parseQuotedString(input, index + 1);
        } else {
            keyResult = parseUnquotedKey(input, index);
        }

        index = keyResult.index;
        c = input.charAt(index);
        if (c === "~") {
            const valueResult = parseComplex(input, index + 1);
            obj[keyResult.element] = valueResult.element;

            index = valueResult.index;
            c = input.charAt(index);
            if (c === "~") {
                index++;
                c = input.charAt(index);
            } else if (c !== ")") {
                err(input,index,c);
            }
        } else {
            err(input,index,c);
        }
    }

    return {element : obj, index : index + 1};
}

//Parse a quoted string. skip escape characters ! and finish on the next '
function parseQuotedString(input: string, index: number): ParsedElement<string> {
    const str = [];
    let c = input.charAt(index);
    while (c !== "'") {
        if (c === "!") { // control character encountered - find next character
            c = input.charAt(++index);
            switch (c) {
                case "!":
                case "'":
                case "_":
                    str.push(c);
                    break;
                default:
                    err(input,index,c);
            }
        } else if (c === "_") { // underscores are replaced with spaces by default
            str.push(" ");
        } else {
            str.push(c);
        }
        index++;
        c = input.charAt(index);
    }
    return {element : str.join(""), index : index + 1};
}

//Parse an unquoted string. finish when the next character that is not a-z,A-Z,0-9, $ or _ is found
function parseUnquotedKey(input: string, startIndex: number): ParsedElement<string> {
    let index = startIndex;
    let c = input.charAt(startIndex);
    if (!(((c >= "a") && (c <= "z")) //First character must be a letter, underscore or percentage
            || ((c >= "A") && (c <= "Z"))
            || ((c === "_") || (c === "$")))) {
        err(input, startIndex, c);
    }

    do {
        index++;
        c = input.charAt(index);
    } while (((c >= "a") && (c <= "z")) // remaining characters may be letters, numbers, underscores or percentages
            || ((c >= "A") && (c <= "Z")) // Unquoted attribute name strings may only contain letters, numbers and _
            || ((c >= "0") && (c <= "9"))
            || ((c === "_") || (c === "$"))); // TODO: Could a regex make this cleaner?

    if (c !== "~") {
        err(input, startIndex, c);
    }

    return {element : input.substring(startIndex, index), index : index};
}

//Parse an unquoted string. finish when the next character that is not a-z,A-Z,0-9 or _ is found
function parsePrimitive(input: string, startIndex: number): ParsedElement<boolean|null|number> | undefined {
    let index = startIndex;
    let c = input.charAt(index);
    
    if (c === "t") {
        if (input.indexOf("true", index) === index) {
            return {element : true, index : index + 4};
        } else {
            err(input,index,c);
        }
    } else if (c === "f") {
        if (input.indexOf("false", index) === index) {
            return {element : false, index : index + 5};
        } else {
            err(input,index,c);
        }
    } else if (c === "n") {
        if (input.indexOf("null", index) === index) {
            return {element : null, index : index + 4};
        } else {
            err(input,index,c);
        }
    } else { // assume number
        while (index < input.length) {
            c = input.charAt(index);
            if ((c === "~") || (c === ")")) {
                break;
            } else if (!(((c >= "0") && (c <= "9"))
                    || (c === "-") || (c === "+") || (c === "e") || (c === "E") || (c === "."))) {
                err(input,index,c);
            }
            index++;
        }
        const str = input.substring(startIndex, index);
        const number = parseFloat(str);
        
        return {element:number, index : index};
    }
}

function renderSimple(element: any, result: any[]) {
    if (element == null) {
        result.push("null");
    } else {
        switch(typeof element){
            case "object":
                if (element instanceof Array) {
                    if (element.length < 2) {
                        renderArray(element, result);
                        return;
                    }
                    
                    for (let a = element.length; a-- > 0;) { // Check if subelements are objects and write complex if they are
                        if (typeof element[a] === "object") {
                            renderArray(element, result);
                            return;
                        }
                    }
                    
                    for (let a = 0; a < element.length; a++) {
                        if (a !== 0) {
                            result.push("~");
                        }
                        renderSimple(element[a], result);
                    }
                } else {
                    renderObject(element,result);
                }
                break;
            case "number":
            case "boolean":
                result.push(element);
                break;
            case "string":
                if((element.indexOf(',') >= 0) 
                    || (element.indexOf('\'') >= 0) 
                    || (element.indexOf('~') >= 0)
                    || (element === "null")
                    || (element === "true")
                    || (element === "false")
                    || isNumber(element)){
                    renderString(element, result);
                }else{
                    result.push(element);
                }
                
            default:
        }
    }
}

function isNumber(value: string) {
    return (value == "NaN") || !isNaN(+value);
}

function render(element: any, result: any[]) {
    if (element == null) {
        result.push("null");
    } else {
        switch(typeof element) {
            case "object":
                if(element instanceof Array){
                    renderArray(element,result);
                }else{
                    renderObject(element,result);
                }
                break;
            case "number":
            case "boolean":
                result.push(element);
                break;
            case "string":
                renderString(element,result);
            default:
        }
    }
}

function renderArray(array: any[], results: any[]) {
    results.push("(!");
    var first = true;
    var len = array.length;
    for (var a = 0; a < len; a++) {
        if (first) {
            first = false;
        } else {
            results.push("~");
        }
        render(array[a], results);
    }
    results.push(")");
}

function renderObject(obj: Record<string, any>, results: any[]) {
    results.push("(");
    let first = true;
    for (let key in obj) {
        if (first) {
            first = false;
        } else {
            results.push("~");
        }

        if (isSimple(key)) {
            results.push(key);
        } else {
            renderString(key, results);
        }

        results.push("~");
        render(obj[key], results);
    }

    results.push(")");
}  

//Render a quoted string
function renderString(str: string, results: any[]) {
    results.push("'");
    for (let i = 0; i < str.length; i++) {
        const c = str.charAt(i);

        if ((c === "!") || (c === "_") || c === "'") {
            results.push("!");
        }

        if (c === " ") {
            results.push("_");
        } else {
            results.push(c);
        }
    }

    results.push("'");
}

//determine if a map key is simple
function isSimple(key: string): boolean {
    const match = key.match("[a-zA-Z0-9$_]+");
    return (match.length === 1) && (match[0].length === key.length) && (key.charAt(0) < "0" || key.charAt(0) > "9");
}

function err(input: string, index: number, c: string) {
    throw new Error(input, index, "Unexpected character '"+c+"' at index "+index+" in: "+input );   
}
